import { useState } from "react";
import FilterCalendar from "../form/FilterCalendar";

function PointLogSearchSection({ search, setSearch, setTab }) {
  const [dateFilter, setDateFilter] = useState({
    range: "All",
    date: new Date().toLocaleDateString(),
  });
  const getPlaceholder = () => {
    let placeholder = "Search by name, email, or phone number";

    return placeholder;
  };

  const handleSearchValueChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="w-full flex flex-col mt-3">
      <div className="flex flex-col md:flex-row items-center gap-2 md:gap-10 justify-between w-full md:overflow-x-scroll scroll-hide">
        <div className="flex flex-1 w-full flex-shrink-0 h-12 py-3 md:py-0 rounded-lg items-center border-2 border-[#DBDBDB] px-4 gap-3 max-w-[500px]">
          <input
            type="text"
            className="flex flex-1 text-sm font-main bg-transparent"
            value={search}
            onChange={handleSearchValueChange}
            placeholder={getPlaceholder()}
          />
          <img src="/IconSearch1.svg" alt="" />
        </div>
        <div>
          <FilterCalendar
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
          />
        </div>
      </div>
    </div>
  );
}

export default PointLogSearchSection;
